import { CoverageSelectedValue, PcCoverage } from '@hsc/common/schemas/pc-common.schema.js';
import { PcPolicyHoldersResponse } from '@hsc/common/schemas/pc-management.schema.js';

export const getPrimaryPolicyHolder = (policyHolders: PcPolicyHoldersResponse) => {
  return policyHolders.find((holder) => holder.policyHolderType === 'PolicyPriNamedInsured');
};

export const isEquipmentBreakdownEnabled = (coverages: PcCoverage[]): boolean => {
  return coverages.some(
    (coverage) =>
      coverage.coverageId === 'EquipmentBreakdown' &&
      coverage.available &&
      coverage.selectedValue.some(
        (value: CoverageSelectedValue) => value.code === 'selected' && value.value === 'true',
      ),
  );
};
